<div class="position-relative">
      <a (click)="onPopupClose()" class="close mat-modal-close"><i class="material-icons">close</i></a>
      <mat-tab-group animationDuration="0ms" dynamicHeight [(selectedIndex)]="TabIndex" (selectedTabChange)="changeTab($event)" class="mat-tab-secondary">
        <mat-tab label="List">
          <ng-template matTabContent>
            <div class="align-items-center">
              <!-- d-flex -->
              <div class="search-input pl-2 mb-2">
                <input type="text" type="search" [(ngModel)]="SearchValue" maxlength="200" (keyup.backspace)="OnBlankInput($event)" class="form-control field-search W-98" placeholder="Press ENTER to search" name="search2" (keyup.enter)="onSearch()" (input)="onInputChange($event)">
              </div>
            </div>
            <div [ngClass]="{'paddingMax' : this.showloader}">
              <app-page-tiny-loader *ngIf="this.showloader" (loaderClosed)="onLoaderClosed()"></app-page-tiny-loader>
            </div>
            <div class="table-responsive table-sticky" *ngIf="!this.showloader">
              <table class="table table-default table-hover">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Created Date</th>
                    <th>Manager</th>
                    <th>Location</th>
                    <th>Location Info</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let b of BussinessUnit; let i = index;">
                    <td matTooltip="{{b.name}}" *ngIf="!isNotSelect">
                      <a style="cursor: pointer;" role="button" href="javascript:void(0);" (click)="SelectBusinessUnit(b)">
                        {{ b.name?.length > 20 ? b.name?.substring(0, 20) + '...' : b.name }}
                      </a>
                    </td>
                    <td matTooltip="{{b.name}}" *ngIf="isNotSelect">
                      {{ b.name?.length > 20 ? b.name?.substring(0, 20) + '...' : b.name }}
                    </td>
                    <td><span matTooltip="{{b.description}}">
                      {{ b.description?.length > 30 ? b.description?.substring(0, 30) + '...' : b.description }}</span></td>
                    <td><span>{{ formatDate(b.foundedDate) }}</span></td>
                    <td><span matTooltip="{{b.managerName}}">{{ b.managerName?.length > 20 ? b.managerName?.substring(0, 20) + '...' : b.managerName }}</span></td>
                    <td><span matTooltip="{{b.location}}">{{ b.location == null ? '-' : b.location?.length > 20 ? b.location?.substring(0, 20) + '...' : b.location }}</span></td>
                    <td><span matTooltip={{b.locationInfo}}>{{ b.locationInfo?.length > 30 ? b.locationInfo.substring(0, 30) + '...' : b.locationInfo }}</span></td>
                    <td class="text-right">
                      <div class="d-flex align-items-center justify-content-end">
                        <span class="material-icons text-primary material-md-icon pointer" matTooltip="Edit" (click)="Edit(b)">edit</span>
                        <span class="material-icons closeicon pointer material-md-icon ml-2" matTooltip="Delete" (click)="clickMethod(b)">close</span>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="nofoundTxt" colspan="7" *ngIf="BussinessUnit.length < 1">
                      <h1><i class="far fa-frown mr-1"></i>&nbsp;No data found!</h1>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <mat-paginator #paginator *ngIf="BussinessUnit?.length > 0" [showFirstLastButtons]="true" [length]="Paginator.Length"
              [pageSize]="Paginator.PageSize" [pageSizeOptions]="Paginator.PageSizeOptions" (page)="setPagination($event)">
              </mat-paginator>
          </ng-template>
        </mat-tab>
        <mat-tab label="{{ Operation }}">
          <ng-template matTabContent>
            <div class="p-3">
              <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
                <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="form-label">Name  <span class="req">*</span></label>
                    <mat-form-field  appearance="outline" class="w-100">
                      <input matInput type="text" id="Name" placeholder="Enter Name" name="Name" (keypress)="removeSpaces($event)"
                      (keypress)="allowAlphaNumericHyphen($event)" (paste)="handlePaste($event,1)" formControlName="Name" maxlength="50">
                    </mat-form-field>
                    <div class="errorMsg ErrorMsgSetting" *ngIf="Submitted && formGroup.get('Name')?.errors">
                      <span *ngIf="formGroup.get('Name')?.errors?.['required']">Name is required</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="form-label">Manager
                    </label>
                    <mat-form-field appearance="outline" class="w-100 material-readonly">
                        <input type="text" id="Manager" placeholder="Enter Manager or space" name="ManagerId" matInput formControlName="ManagerId"
                        [ngClass]="{ 'is-invalid': Submitted && formGroup.get('ManagerId')?.value??0 == 0 }"
                        [matAutocomplete]="auto1" (input)="filterManager($event)" class="field-control blackColor" readonly="true">
                        <mat-autocomplete #auto1="matAutocomplete" [displayWith]="displayWithManager"
                        (closed)="onClosedCallback(filteredManagers,ManagerListData, formGroup, 'ManagerId', 'fullName')"
                        (optionSelected)="onSelectionCallback($event, formGroup, 'ManagerId', 'fullName')">
                          <mat-option *ngFor="let option of filteredManagers" [value]="option"
                          [matTooltip]="option?.fullName?.length > 45 ? option?.fullName : ''">
                            {{option?.fullName?.length > 45 ? option?.fullName?.substring(0, 45) + '...' : option.fullName }}
                          </mat-option>
                          <mat-option *ngIf="filteredManagers?.length === 0" disabled class="no-data-option">
                            Manager Not Found!
                          </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <div class="errorMsg ErrorMsgSetting" *ngIf="Submitted && formGroup.get('ManagerId')?.errors">
                        <span *ngIf="formGroup.get('ManagerId')?.errors?.['required']">Manager is required</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="form-label">Location<span class="req">*</span> <app-on-page-loader [isLoading]="IsLocationLoading"></app-on-page-loader>
                      <span class="text-primary float-right ml-auto" matTooltip="If you know the name then please type it otherwise press space">
                        <i class="info-icon" ><img src="assets/images/info-icon.svg" /></i>
                     </span>
                    </label>
                    <div class="input-group-mat">
                      <mat-form-field   appearance="outline" class="w-100">
                        <input type="text" id="Location" placeholder="Enter Location or space" name="LocationId" matInput formControlName="LocationId"
                        [matAutocomplete]="auto" (input)="filterLocations($event)" class="field-control" [ngClass]="{ 'is-invalid': Submitted && formGroup.get('LocationId')?.errors }">
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWithLoc"
                        (closed)="onClosedCallback(filteredLocations,LocationListData, formGroup, 'LocationId', 'locationInfo')"
                        (optionSelected)="onSelectionCallback($event, formGroup, 'LocationId', 'locationInfo')">
                          <mat-option *ngFor="let option of filteredLocations; let last = last" [value]="option" [ngStyle]="{'border-bottom': last ? 'none' : '1px solid #ccc'}">
                            {{ option.locationInfo }}
                          </mat-option>
                          <mat-option *ngIf="filteredLocations?.length === 0 && IsLocEnter" disabled class="no-data-option">
                            Location Not Found!
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                      <button class="btn btn-md btn-gray input-group-mat-btn" type="button" (click)="location_popup()" appHasPermission="Permissions.Location.Create" matTooltip="Add/Edit Location">
                        <span class="material-symbols-outlined">
                          format_list_bulleted
                          </span></button>
                    </div>
                    <div class="errorMsg ErrorMsgSetting" *ngIf="Submitted">
                      <div *ngIf="formGroup.get('LocationId')?.errors?.['required']">Location is required</div>
                    </div>
                  </div>
                </div>
             </div>
             <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="form-label">Description  <span class="req">*</span>
                      <i class="info-icon pointer" matTooltipPosition="above" matTooltip="Maximum 200 Characters Allowed Special Characters allowed , : - . /"></i>
                    </label>
                    <mat-form-field  appearance="outline" class="w-100">
                      <textarea matInput id="Description" placeholder="Enter Description." name="Description" formControlName="Description" (keypress)="removeSpaces($event)"
                       cdkAutosizeMinRows="3" required class="field-control resizeno" maxlength="200"></textarea>
                    </mat-form-field>
                    <div class="errorMsg ErrorDesMsgSetting" *ngIf="Submitted && formGroup.get('Description')?.errors">
                      <span *ngIf="formGroup.get('Description')?.errors?.['required']">Description is required</span>
                    </div>
                  </div>
                </div>
              </div>
                <div class="ml-auto text-right">
                  <button type="button" class="btn btn-secondary mr-2" (click)="gotoBack()">Back</button>
                  <button type="submit" class="btn btn-primary">{{ Operation }}</button>
                </div>
              </form>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
  </div>
